import React from "react";

import { CONTACT_DETAILS } from "../../utils/stateTypes";

//Orange title band at the top of each inner page
export const PageBanner = ({ title }) => (
  <div className={"page-banner"}>
    <h1>{title}</h1>
  </div>
);

//Full width decorative photo between sections, fixed while the page scrolls over it (like the original site).
//"fixedPosition" is used while the effect is on - it is relative to the screen rather than the band, so may need to differ
export const ImageBand = ({ image, position = "center", fixedPosition = position }) => (
  <div
    className={"image-band parallax"}
    style={{
      "--bg-image": `url(${image})`,
      "--bg-position": position,
      "--bg-fixed-position": fixedPosition,
    }}
    role={"presentation"}
  />
);

//Address / email / phone block - used on the home and contact pages
export const ContactDetails = ({ className = "" }) => (
  <address className={`contact-details ${className}`}>
    <h3>Address</h3>
    <p>
      <a
        href={CONTACT_DETAILS.MAP_LINK}
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        {CONTACT_DETAILS.ADDRESS.map((line) => (
          <React.Fragment key={line}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </a>
    </p>
    <h3>Email</h3>
    <p>
      <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
    </p>
    <h3>Phone</h3>
    <p>
      {CONTACT_DETAILS.PHONES.map((phone) => (
        <React.Fragment key={phone.link}>
          <a href={phone.link}>{phone.label}</a>
          <br />
        </React.Fragment>
      ))}
    </p>
  </address>
);
